export default function SystemSelector({ label, systems, value, onChange, systemLabels }) {
  return (
    <div>
      <label className="block text-sm font-medium text-slate-300 mb-2">{label}</label>
      <div className="flex flex-wrap gap-2">
        {systems.map((sys) => (
          <button
            key={sys.id}
            type="button"
            onClick={() => onChange(sys.id)}
            className={`rounded-full px-4 py-2 text-sm font-medium transition-colors border ${
              value === sys.id
                ? 'bg-emerald-600 border-emerald-500 text-white'
                : 'bg-slate-800 border-slate-700 text-slate-200 hover:border-emerald-600/50'
            }`}
          >
            {systemLabels[sys.labelKey] || sys.id.toUpperCase()}
          </button>
        ))}
      </div>
    </div>
  );
}
